export const ACTION_UPDATE_CALENDAR_OPEN = '@rails/ACTION_UPDATE_CALENDAR_OPEN';
export const ACTION_UPDATE_FROM_STATION_NODE = '@rails/ACTION_UPDATE_FROM_STATION_NODE';
export const ACTION_UPDATE_TO_STATION_NODE = '@rails/ACTION_UPDATE_TO_STATION_NODE';
export const ACTION_UPDATE_TRAIN_NUMBER = '@rails/ACTION_UPDATE_TRAIN_NUMBER';
export const ACTION_UPDATE_TO_CITY_NAME = '@rails/ACTION_UPDATE_TO_CITY_NAME';
export const ACTION_UPDATE_FROM_CITY_NAME = '@rails/ACTION_UPDATE_FROM_CITY_NAME';
